import ACTION_ITEMS from '../../../actionItems';

export const setPsychSelectedCandidate = (candidate) => (dispatch) => {
  dispatch({
    type: ACTION_ITEMS.PSYCHOMETRIC.SELECTED_CANDIDATE.SET,
    payload: candidate,
  });
};
